import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
import { Observable } from 'rxjs';

const API_URL = environment.apiUrl + 'mycoach';

@Injectable({
  providedIn: 'root'
})
export class MyCoachService {
  authtoken: string;
  private httpOptions;

  constructor(private http: HttpClient, private token: TokenStorageService) {
    this.authtoken = this.token.getToken();
    this.httpOptions = {
      headers: new HttpHeaders()
        .set("Content-Type", "application/json")
        .set('Authorization', `Bearer ${this.authtoken}`)
    };
  }

  getMyCoaches(query): Observable<any> {
    return this.http.get(API_URL + query, this.httpOptions);
  }

  getMyCoachDetails(id): Observable<any> {
    return this.http.get(API_URL + '/' + id, this.httpOptions);
  }

  updateMyCoach(id, data): Observable<any> {
    return this.http.put(API_URL + '/' + id, data, this.httpOptions);
  }

  addMyCoach(data): Observable<any> {
    return this.http.post(API_URL, data, this.httpOptions);
  }

  deleteMyCoach(id): Observable<any> {
    return this.http.delete(API_URL + '/' + id, this.httpOptions);
  }
}